module.exports = __webpack_public_path__ + "media/images/app/homepage/section-subscription-8bc32cfe4c7026649c8d37775232edd3.webp";